import axios from 'axios';
import NProgress from 'nprogress';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token and start loading
api.interceptors.request.use(
  (config) => {
    NProgress.start();
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors and stop loading
api.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    
    const isAuthPage = ['/', '/login', '/register', '/forgot-password', '/reset-password', '/verify-email'].some(
      path => window.location.pathname === path || 
              (path !== '/' && window.location.pathname.startsWith(path))
    );
    
    // Only redirect on 401 if we're not already on auth pages
    if (error.response?.status === 401 && !isAuthPage) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api;
